import React, { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import Link from '../../_shared/components/Link';
import ROUTES from '../Routes/constants';

import { StyledNavItem } from './Styles';

const propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  testId: PropTypes.string,
  children: PropTypes.node,
  context: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  linkTo: PropTypes.string,
  updatePositionHandler: PropTypes.func,
  isActive: PropTypes.bool,
  onClick: PropTypes.func
};

const defaultProps = {
  testId: undefined,
  children: undefined,
  context: undefined,
  linkTo: '',
  updatePositionHandler: () => {},
  isActive: false,
  onClick: () => null,
  id: undefined
};

const NavItem = ({
  id,
  linkTo,
  context,
  children,
  testId,
  updatePositionHandler,
  isActive,
  onClick
}) => {
  const dispatch = useDispatch();
  const ref = useRef();

  useEffect(() => {
    if (isActive && typeof updatePositionHandler === 'function') {
      const { left, width } = ref?.current?.getBoundingClientRect();

      if (left && width) {
        dispatch(
          updatePositionHandler({
            left,
            width,
            context
          })
        );
      }
    } else if (window.location.pathname === ROUTES.PAYMENTS_ON_HOLD) {
      dispatch(
        updatePositionHandler({
          left: 'auto',
          width: 'auto',
          context: undefined
        })
      );
    }
  }, [dispatch, ref, isActive, updatePositionHandler, context]);

  return (
    <StyledNavItem data-testid={testId} active={isActive} id={id} name={testId}>
      <Link
        to={linkTo}
        ref={ref}
        onClick={onClick}
        isActive={() => {
          return isActive;
        }}
      >
        {children}
      </Link>
    </StyledNavItem>
  );
};

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

export default NavItem;
